import { Box } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";

export function DetectorDetailAnswers() {
  return (
    <Box className="flex h-[50px] pb-[10px] justify-between gap-6">
      <Box className="flex w-[50%] justify-center items-center gap-2 md:gap-6 border-hl-purple border-b-2 border-solid">
        <Typography fontWeight="semibold" textTransform="uppercase" className="text-gray-600">
          Answer 1:
        </Typography>
        <Typography variant="subtitle" fontWeight="bold">
          Yes
        </Typography>
      </Box>
      <Box className="flex w-[50%] justify-center items-center gap-2 md:gap-6 border-hl-magenta border-b-2 border-solid">
        <Typography fontWeight="semibold" textTransform="uppercase" className="text-gray-600">
          Answer 2:
        </Typography>
        <Typography variant="subtitle" fontWeight="bold">
          No
        </Typography>
      </Box>
    </Box>
  );
}
